/* eslint-disable */
import { GADataLayer } from '../models/services.model';

export const mockGAData: GADataLayer = {
  event: 'genericGAEvent',
  category: 'pageName',
  action: 'button-clicked',
  label: 'button-cta',
};
